import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Test3 from '@/views/test3.vue'
import Ad1 from '@/views/Ad1.vue'
import Ad2 from '@/views/Ad2.vue'
import Ad3 from '@/views/Ad3.vue'
import Ad4 from '@/views/Ad4.vue'
import chat from '@/views/chat.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/test3',
    name: 'Test3',
    component:Test3
  },
    {
    path: '/ad1',
    name: 'Ad1',
    component:Ad1
  },
      {
    path: '/ad2',
    name: 'Ad2',
    component:Ad2
  },
        {
    path: '/ad3',
    name: 'Ad3',
    component:Ad3
  },
        {
    path: '/ad4',
    name: 'Ad4',
    component:Ad4
  },
  {
    path: '/chat',
    name: 'chat',
    component:chat
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
